import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Lock, Mail, User } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import { formatApiError } from "../api";

const Register = () => {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (password.length < 6) {
      setError("Password must be at least 6 characters.");
      return;
    }
    setLoading(true);
    try {
      const user = await register({ name: name.trim(), email: email.trim(), password });
      toast.success(`Welcome, ${user.name}`);
      navigate("/account", { replace: true });
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[78vh] flex items-center justify-center px-6 py-16">
      <form onSubmit={submit} className="w-full max-w-md bg-[#141210] border border-[#2c2822] rounded-2xl p-8 md:p-10" data-testid="register-form">
        <p className="text-[#c9a24b] text-xs tracking-[0.3em] uppercase text-center mb-3">Join Kanama Naturals</p>
        <h1 className="font-display text-3xl text-[#f4efe4] text-center mb-8">Create Account</h1>

        <label className="block text-[#a29a8c] text-xs tracking-[0.12em] uppercase mb-2">Full Name</label>
        <div className="relative mb-5">
          <User size={16} className="absolute left-4 top-1/2 -translate-y-1/2 text-[#6b6459]" />
          <input type="text" value={name} onChange={(e) => setName(e.target.value)} required data-testid="register-name"
            className="w-full bg-[#0b0a09] border border-[#2c2822] rounded-md pl-11 pr-4 py-3 text-[#f4efe4] outline-none focus:border-[#c9a24b] transition-colors" placeholder="Jane Doe" />
        </div>

        <label className="block text-[#a29a8c] text-xs tracking-[0.12em] uppercase mb-2">Email</label>
        <div className="relative mb-5">
          <Mail size={16} className="absolute left-4 top-1/2 -translate-y-1/2 text-[#6b6459]" />
          <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="register-email"
            className="w-full bg-[#0b0a09] border border-[#2c2822] rounded-md pl-11 pr-4 py-3 text-[#f4efe4] outline-none focus:border-[#c9a24b] transition-colors" placeholder="you@email.com" />
        </div>

        <label className="block text-[#a29a8c] text-xs tracking-[0.12em] uppercase mb-2">Password</label>
        <div className="relative mb-6">
          <Lock size={16} className="absolute left-4 top-1/2 -translate-y-1/2 text-[#6b6459]" />
          <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="register-password"
            className="w-full bg-[#0b0a09] border border-[#2c2822] rounded-md pl-11 pr-4 py-3 text-[#f4efe4] outline-none focus:border-[#c9a24b] transition-colors" placeholder="At least 6 characters" />
        </div>

        {error && <p className="text-red-400 text-sm mb-5" data-testid="register-error">{error}</p>}

        <button type="submit" disabled={loading} data-testid="register-submit"
          className="btn-gold w-full py-3.5 rounded-full text-sm tracking-[0.2em] uppercase font-medium disabled:opacity-60">
          {loading ? "Creating…" : "Create Account"}
        </button>

        <p className="text-[#a29a8c] text-sm text-center mt-6">
          Already have an account?{" "}
          <Link to="/login" className="text-[#c9a24b] hover:underline" data-testid="go-login">Sign in</Link>
        </p>
      </form>
    </div>
  );
};

export default Register;
